<template>
  <div class="bg-white">
    <div class="overflow-hidden bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="relative mb-8 md:mb-2 md:px-6">
          <div class="max-w-prose text-base lg:max-w-none">
            <h2 class="font-semibold leading-6 text-teal-600">
              Feedback geben
            </h2>
            <p class="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              Hilf uns das Beta vom St. Audio Studio zu streichen
            </p>
          </div>
        </div>
        <div class="relative">
          <div class="relative md:bg-white md:p-6">
            <div class="lg:grid lg:grid-cols-2 lg:gap-6">
              <div class="prose prose-lg prose-teal text-gray-500 lg:max-w-none">
                <p>Dein Wegweiser für Podcast-Wachstum befindet sich aktuell im Beta-Test, in dem die Funktionalität fortlaufend ausgebaut und Fehler behoben werden.</p>
                <p>Das Ziel dieser Entwicklungsphase ist es die Grundfunktionen vom Entdecken bis hin zur Anwendung von Reichweitenmethoden zu testen und den Assistenten (im Schwebebutton unten rechts) mit echten Anwendungsfällen und Daten zu trainieren.</p>
                <p>Bis hier hin haben wir alle Methoden nach bestem Gewissen und in Abstimmung mit Podcast-Expert*innen beschrieben und in ihre Reichweiten-Potentiale eingeordnet, sowie einige bereits um Schritt-für-Schritt-Anleitungen und Best Practices ergänzt.</p>
                <p>Doch das soll erst der Anfang sein! Denn wir sind Fans vom Co-Creation-Prozess und wollen das Tool in engem Austausch mit unserer Community weiterentwickeln. Darum teile uns bitte immer wieder mit, was dir bei der Nutzung aufgefallen ist oder noch nicht so funktioniert, wie es sollte.</p>
                <p>Mit deinem Input können wir Podcaster*innen dazu befähigen sich ihre Audience selbst auf- und auszubauen. Danke, dass du uns bei dieser Mission unterstützt und von Anfang an dabei bist.</p>
              </div>
              <div class="prose prose-lg prose-teal mt-6 text-gray-500 lg:mt-0">
                <p>Besonders interessiert sind wir an Feedback zu den folgenden Fragen:</p>
                <ul role="list">
                  <li>Um welche Aspekte müssen Methoden noch ergänzt werden, damit du ein vollständiges Bild von Potentialen und Anwendung erhältst?</li>
                  <li>Liegen wir mit der Potential-Einordnung einer bestimmten Methoden deiner Meinung nach daneben?</li>
                  <li>Hast du selbst weitere Ideen für Methoden, die auf das eine oder andere Wachstumsziel einzahlen können?</li>
                  <li>Wie müssen Experimente gestaltet sein, damit sie dich noch besser anleiten und schneller ans Ziel bringen?</li>
                  <li>Auf welches Features möchtest du nicht mehr verzichten?</li>
                  <li>Was läuft noch nicht wie erwartet?</li>
                  <li>Brauchst du eventuell Unterstützung bei der Umsetzung von Experimenten? Wir schauen gerne, ob wir oder jemand aus unserem Netzwerk supporten können.</li>
                  <li>Welche Podcast-Challenges würdest du mit St. Audio neben dem Wachstum noch strukturiert angehen wollen?</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="relative md:bg-white md:p-6">
            <div class="lg:grid lg:grid-cols-2 lg:gap-6">
              <div class="prose prose-lg prose-teal text-gray-500 lg:max-w-none">
                <p>PS: Wenn dich interessiert, welche neuen Features wir bereits in Planung haben und worauf du dich als nächstes freuen kannst, dann wirf unbedingt auch einen Blick in die <a href="https://sanktaudio.de/roadmap" target="_blank">Roadmap mit allen Ausbaustufen</a>.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 rounded-lg">
          <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              <span class="block">Fehler gefunden oder Idee für Ausbaustufe?</span>
              <span class="block text-teal-600">Teile dein Feedback jetzt mit uns.</span>
            </h2>
            <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div class="inline-flex rounded-md shadow">
                <a href="mailto:feedback@sanktaudio.de" class="inline-flex items-center justify-center rounded-md border border-transparent bg-teal-600 px-5 py-3 text-base font-medium text-white hover:bg-teal-700">E-Mail</a>
              </div>
              <div class="ml-3 inline-flex rounded-md shadow">
                <a href="https://twitter.com/staudio" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-teal-600 hover:bg-teal-50">Twitter</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
